/* eslint-disable camelcase */
import altruism_normal_svg from 'images/altruism-normal.svg';
import autonomy_normal_svg from 'images/autonomy-normal.svg';
import competition_normal_svg from 'images/competition-normal.svg';
import feedback_normal_svg from 'images/feedback-normal.svg';
import financial_needs_normal_svg from 'images/financial-needs-normal.svg';
import innovation_normal_svg from 'images/innovation-normal.svg';
import progress_normal_svg from 'images/progress-normal.svg';
import rationality_normal_svg from 'images/rationality-normal.svg';
import security_normal_svg from 'images/security-normal.svg';
import status_normal_svg from 'images/status-normal.svg';
import social_relationships_normal_svg from 'images/social-relationships-normal.svg';


import altruism_filled_svg from 'images/altruism-filled.svg';
import autonomy_filled_svg from 'images/autonomy-filled.svg';
import competition_filled_svg from 'images/competition-filled.svg';
import feedback_filled_svg from 'images/feedback-filled.svg';
import financial_needs_filled_svg from 'images/financial-needs-filled.svg';
import innovation_filled_svg from 'images/innovation-filled.svg';
import progress_filled_svg from 'images/progress-filled.svg';
import rationality_filled_svg from 'images/rationality-filled.svg';
import security_filled_svg from 'images/security-filled.svg';
import status_filled_svg from 'images/status-filled.svg';
import social_relationships_filled_svg from 'images/social-relationships-filled.svg';

export const ID_SORTED_SCALES = [
    'security',
    'status',
    'social_relationships',
    'competition',
    'rationality',
    'progress',
    'feedback',
    'innovation',
    'altruism',
    'financial_needs',
    'autonomy'
];

export const MOTIVATOR_ICONS_NORMAL_SVG = {
    altruism_normal_svg,
    autonomy_normal_svg,
    competition_normal_svg,
    feedback_normal_svg,
    financial_needs_normal_svg,
    innovation_normal_svg,
    progress_normal_svg,
    rationality_normal_svg,
    security_normal_svg,
    status_normal_svg,
    social_relationships_normal_svg
};

export const MOTIVATOR_ICONS_FILLED_SVG = {
    altruism_filled_svg,
    autonomy_filled_svg,
    competition_filled_svg,
    feedback_filled_svg,
    financial_needs_filled_svg,
    innovation_filled_svg,
    progress_filled_svg,
    rationality_filled_svg,
    security_filled_svg,
    status_filled_svg,
    social_relationships_filled_svg
};

export const MOTIVATOR_COLORS = {
    innovation: '#d482bd',
    altruism: '#59be71',
    autonomy: '#54c4c3',
    security: '#f7b844',
    progress: '#ef6d45',
    status: '#c0c0c0',
    financial_needs: '#d2a952',
    competition: '#DA5957',
    feedback: '#7FB15B',
    rationality: '#408BC9',
    social_relationships: '#EC619F'
};
